"use strict";

exports.__esModule = true;
exports.splitStringArray = void 0;

const splitStringArray = (array, separator = /[,;]/) => array.flatMap(values => values.split(separator).map(value => value.trim()).filter(Boolean)).filter(values => values.length > 0);

exports.splitStringArray = splitStringArray;